//
//
//
//
//
//
//
//
//
//

// TODO:BRO-1276: import DTacoRating from '@appsumo/dorado-nuxt';
import TacoRating from '../../utilities/TacoRating.vue';

export default {
  name: 'PDPCommentRatings',
  components: {
    TacoRating,
  },
  props: {
    rating: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    mockDeal() {
      return {
        deal_review: {
          review_count: this.rating,
          average_rating: this.rating,
        },
      };
    },
  },
};
